function parseNonNegativeBigInt(value: string): bigint {
  if (!/^\d+$/.test(value.trim())) {
    return 0n;
  }

  try {
    return BigInt(value);
  } catch {
    return 0n;
  }
}

export function rankProgressPercent({
  metric,
  nextThreshold,
}: {
  metric: string;
  nextThreshold?: string | null;
}): number {
  if (nextThreshold == null || nextThreshold === '') {
    return 100;
  }

  const next = parseNonNegativeBigInt(nextThreshold);
  if (next <= 0n) {
    return 0;
  }

  const used = parseNonNegativeBigInt(metric);
  if (used <= 0n) {
    return 0;
  }

  if (used >= next) {
    return 100;
  }

  return Number((used * 100n) / next);
}
